import { useExternalReferrer, useUtmEntries } from "~/helpers/attribution";

/**
 * Hidden campaign fields for the contact and booking forms, so /admin shows
 * which ad or link a lead came from. Renders nothing for direct visits.
 */
export default function AttributionFields() {
  const utm = useUtmEntries();
  const referrer = useExternalReferrer();

  return (
    <>
      {utm.map(([name, value]) => (
        <input key={name} type="hidden" name={name} value={value} />
      ))}
      {referrer ? (
        <input type="hidden" name="referrer" value={referrer} />
      ) : null}
    </>
  );
}
